import AccountsView from 'features/Accounts/AccountsView'
import AnnouncementsView from 'features/Concierge/Announcements/AnnouncementsView'
import ConciergeView from 'features/Concierge/ConciergeView'
import FaqView from 'features/Concierge/Faq/FaqView'
import DashboardView from 'features/Dashboard/DashboardView'
import LocationDetailView from 'features/Dashboard/LocationDetailView'
import ProgramDetailView from 'features/Dashboard/ProgramDetailView'
import ReportedUsageDataView from 'features/Dashboard/ReportedUsageDataView'
import {
  MerchantConnectionView,
  MerchantConnectionsView,
} from 'features/Dashboard/MerchantConnectionPages'
import SiteDetailView from 'features/Dashboard/SiteDetailView'
import FlexActivationView from 'features/Flex/Activation/FlexActivationView'
import FlexPrograms from 'features/Flex/FlexPrograms'
import FlexManageView from 'features/Flex/Manage/FlexManageView'
import FlexView from 'features/Flex/Overview/FlexView'
import GRHActivationView from 'features/GRH/Activation/GRHActivationView'
import GRHPrograms from 'features/GRH/GRHPrograms'
import GRHManageView from 'features/GRH/Manage/GRHManageView'
import GRHView from 'features/GRH/Overview/GRHView'
import OTPActivationView from 'features/OTP/Activation/OTPActivationView'
import OTPPrograms from 'features/OTP/OTPPrograms'
import OTPManageView from 'features/OTP/Manage/OTPManageView'
import OTPView from 'features/OTP/Overview/OTPView'
import ActivateIncentiveView from 'features/Incentives/Activation/ActivateIncentiveView'
import IncentivePrograms from 'features/Incentives/IncentivePrograms'
import IncentivesManageView from 'features/Incentives/Manage/IncentivesManageView'
import OTRHistoryView from 'features/OTR/OTRHistoryView'
import TripsView from 'features/Incentives/Trips/TripsView'
import LeaderboardActivationView from 'features/Leaderboards/Activation/LeaderboardActivationView'
import LeaderboardsPrograms from 'features/Leaderboards/LeaderboardsPrograms'
import LeaderboardsView from 'features/Leaderboards/LeaderboardsView'
import ManageLeaderboardView from 'features/Leaderboards/Management/ManageLeaderboardView'
import ProgramRecommenderView from 'features/ProgramRecommender/ProgramRecommenderView'
import MicromobilityActivationView from 'features/Micromobility/Activation/MicromobilityActivationView'
import MicromobilityManageView from 'features/Micromobility/Manage/MicromobilityManageView'
import MicromobilityPrograms from 'features/Micromobility/MicromobilityPrograms'
import MicromobilityView from 'features/Micromobility/Overview/MicromobilityView'
import LaunchProgramView from 'features/Programs/Launch/LaunchProgramView'
import ProgramsEditingView from 'features/Programs/Editing/ProgramsEditingSummaryView'
import ProgramsOverviewView from 'features/Programs/Overview/OverviewView'
import ProgramSuccessView from 'features/Programs/Success/ProgramSuccessView'
import ProviderCatalogView from 'features/ProviderCatalog/ProviderCatalogView'
import QTFActivationView from 'features/QTF/Activation/QTFActivationView'
import QTFManageView from 'features/QTF/Manage/QTFManageView'
import QTFView from 'features/QTF/Overview/QTFView'
import QTFPrograms from 'features/QTF/QTFPrograms'
import ReimbursementSubmissionsView from 'features/Reimbursements/components/ReimbursementSubmissionsView'
import ReimbursementDetailsView from 'features/Reimbursements/components/ReimbursementDetailsView'
import ComplianceView from 'features/Compliance/ComplianceView'
import ReportingView from 'features/Report/ReportingView'
import SegmentsView from 'features/Segments/SegmentsView'
import UploadHistoryView from 'features/Segments/UploadHistoryView'
import React from 'react'
import { Route } from 'react-router-dom'
import DefaultLayout from './DefaultLayout'
import { Locations } from './Locations'
import OptInPrograms from 'features/OptIn/OptInPrograms'
import OptInOverviewView from 'features/OptIn/Overview/OptInOverviewView'
import OptInQuestionOverviewView from 'features/OptIn/QuestionOverview/OptInQuestionOverviewView'
import TransitPassAdminView from 'features/TransitPass/TransitPassAdminView'
import Performance from 'employee-platform/features/Admin-concierge/Performance'
import Overview from 'employee-platform/features/Admin-concierge/Overview'
import Insights from 'employee-platform/features/Admin-concierge/Insights'
import TopicsExplorer from 'employee-platform/features/Admin-concierge/Topics-Explorer'
import Optimize from 'employee-platform/features/Admin-concierge/Optimize'
import Configuration from 'employee-platform/features/Admin-concierge/Configuration'

const AdminRoutes = () => (
  <>
    {/* Main App */}
    <Route path={'/'} element={<DefaultLayout />}>
      <Route path={Locations.Dashboard} element={<DashboardView />} />
      <Route
        path={Locations.DashboardLocation}
        element={<LocationDetailView />}
      />
      <Route path={Locations.DashboardSite} element={<SiteDetailView />} />
      <Route
        path={Locations.DashboardProgram}
        element={<ProgramDetailView />}
      />
      <Route
        path={Locations.DashboardProgramData}
        element={<ReportedUsageDataView />}
      />
      <Route
        path={Locations.DashboardProgramConnection}
        element={<MerchantConnectionView />}
      />
      <Route
        path={Locations.DashboardProgramConnections}
        element={<MerchantConnectionsView />}
      />
      <Route path={Locations.Accounts.Profile} element={<AccountsView />} />
      <Route path={Locations.Accounts.Billing} element={<AccountsView />} />

      <Route path={Locations.Analysis} element={<ProgramRecommenderView />} />
      <Route
        path={Locations.Segments.UploadHistory}
        element={<UploadHistoryView />}
      />
      <Route path={Locations.Concierge.Faq} element={<FaqView />} />
      <Route
        path={Locations.Concierge.Announcement}
        element={<AnnouncementsView />}
      />

      {/* Incentives */}
      <Route
        path={Locations.Incentives.Programs}
        element={<IncentivePrograms />}
      />
      <Route
        path={Locations.Incentives.Activation}
        element={<ActivateIncentiveView />}
      />
      <Route
        path={Locations.Incentives.Manage}
        element={<IncentivesManageView />}
      />
      <Route path={Locations.Incentives.Trips} element={<TripsView />} />

      {/* OTR */}
      <Route
        path={Locations.Incentives.OTRHistory}
        element={<OTRHistoryView />}
      />
      <Route path={Locations.OTR.OTRHistory} element={<OTRHistoryView />} />

      {/* Leaderboards */}
      <Route
        path={Locations.Leaderboards.Programs}
        element={<LeaderboardsPrograms />}
      />
      <Route
        path={Locations.Leaderboards.Programs}
        element={<LeaderboardsPrograms />}
      />
      <Route
        path={Locations.Leaderboards.Leaderboards}
        element={<LeaderboardsView />}
      />
      <Route
        path={Locations.Leaderboards.Manage}
        element={<ManageLeaderboardView />}
      />
      <Route
        path={Locations.Leaderboards.Activation}
        element={<LeaderboardActivationView />}
      />

      {/* Concierge */}
      <Route path={Locations.Concierge.Concierge} element={<ConciergeView />} />

      {/* Admin Concierge */}
      <Route
        path={Locations.AdminConcierge.Performance}
        element={<Performance />}
      />
      <Route path={Locations.AdminConcierge.Overview} element={<Overview />} />
      <Route path={Locations.AdminConcierge.Insights} element={<Insights />} />
      <Route
        path={Locations.AdminConcierge.TopicsExplorer}
        element={<TopicsExplorer />}
      />
      <Route path={Locations.AdminConcierge.Optimize} element={<Optimize />} />
      <Route
        path={Locations.AdminConcierge.Configuration}
        element={<Configuration />}
      />

      {/* Flex */}
      <Route path={Locations.Flex.Programs} element={<FlexPrograms />} />
      <Route path={Locations.Flex.Overview} element={<FlexView />} />
      <Route
        path={Locations.Flex.Activation}
        element={<FlexActivationView />}
      />
      <Route path={Locations.Flex.Manage} element={<FlexManageView />} />

      {/* Micromobility */}
      <Route
        path={Locations.Micromobility.Programs}
        element={<MicromobilityPrograms />}
      />
      <Route
        path={Locations.Micromobility.Overview}
        element={<MicromobilityView />}
      />
      <Route
        path={Locations.Micromobility.Activation}
        element={<MicromobilityActivationView />}
      />
      <Route
        path={Locations.Micromobility.Manage}
        element={<MicromobilityManageView />}
      />

      {/* QTF */}
      <Route path={Locations.QTF.Programs} element={<QTFPrograms />} />
      <Route path={Locations.QTF.Overview} element={<QTFView />} />
      <Route path={Locations.QTF.Activation} element={<QTFActivationView />} />
      <Route
        path={Locations.QTF.ActivationOnboarding}
        element={<QTFActivationView isOnboarding={true} />}
      />
      <Route
        path={Locations.QTF.ActivationDefault}
        element={<QTFActivationView isOnboarding={false} />}
      />
      <Route path={Locations.QTF.Manage} element={<QTFManageView />} />

      {/* GRH */}
      <Route path={Locations.GRH.Programs} element={<GRHPrograms />} />
      <Route path={Locations.GRH.Overview} element={<GRHView />} />
      <Route path={Locations.GRH.Activation} element={<GRHActivationView />} />
      <Route path={Locations.GRH.Manage} element={<GRHManageView />} />

      {/* OPT IN */}
      <Route path={Locations.OptIn.Programs} element={<OptInPrograms />} />
      <Route path={Locations.OptIn.Overview} element={<OptInOverviewView />} />
      <Route
        path={Locations.OptIn.QuestionOverview}
        element={<OptInQuestionOverviewView />}
      />

      {/* OTP */}
      <Route path={Locations.OTP.Programs} element={<OTPPrograms />} />
      <Route path={Locations.OTP.Overview} element={<OTPView />} />
      <Route path={Locations.OTP.Activation} element={<OTPActivationView />} />
      <Route path={Locations.OTP.Manage} element={<OTPManageView />} />
      <Route
        path={Locations.ProviderCatalog}
        element={<ProviderCatalogView />}
      />
      <Route path={Locations.Segments.Overview} element={<SegmentsView />} />

      {/* Programs */}
      <Route
        path={Locations.Programs.Overview}
        element={<ProgramsOverviewView />}
      />
      <Route path={Locations.Programs.Launch} element={<LaunchProgramView />} />
      <Route path={Locations.Programs.Edit} element={<ProgramsEditingView />} />
      <Route
        path={Locations.Programs.Success}
        element={<ProgramSuccessView />}
      />

      {/* Report */}
      <Route path={Locations.Reporting} element={<ReportingView />} />

      {/* Compliance */}
      <Route path={Locations.Compliance} element={<ComplianceView />} />

      {/* Reimbursement Submissions */}
      <Route
        path={Locations.ReimbursementSubmissions}
        element={<ReimbursementSubmissionsView />}
      />
      <Route
        path={Locations.ReimbursementDetails}
        element={<ReimbursementDetailsView />}
      />

      {/* Transit Pass */}
      <Route path={Locations.TransitPass} element={<TransitPassAdminView />} />
    </Route>
  </>
)

export default AdminRoutes
